/**
 * /cart -> drawer redirect (O-11, decided).
 *
 * Live behaviour, reproduced: with JavaScript and the drawer enabled, visiting
 * the cart route bounces to the storefront root with `?drawer=open`, where
 * cart-drawer.js opens the drawer.
 *
 * Live bug, fixed: live matched `location.pathname.includes('/cart')`, which
 * also bounced /pages/cart-hilfe and any other path merely containing "/cart".
 * The fix is structural + explicit:
 *   - structural: this script is loaded ONLY by sections/main-cart-items.liquid,
 *     i.e. only the cart template can execute it;
 *   - explicit: it still verifies the pathname is exactly the locale-aware cart
 *     route (`Shopify.routes.root + 'cart'`) before acting, so even a copy-paste
 *     of this file into a global load-site cannot reproduce the live bug.
 *
 * Locale-aware via window.Shopify.routes.root ('/', '/en-nl/', ...). No cart
 * reads, no cart writes (R-01).
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartPath = root + 'cart';
  var path = location.pathname;
  if (path === cartPath || path === cartPath + '/') {
    location.replace(root + '?drawer=open');
  }
})();
